import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import _isEmpty from 'lodash/isEmpty';
import _includes from 'lodash/includes';
import _find from 'lodash/find';
import CONST from '@/utils/Constants/General';

// import context
import { useRecipeFilterContext } from '@/context/recipeFilter';

// import components
import Select from '@/components/molecules/Select';
import FilterAutocomplete from '@/components/organisms/ServiceFilter/FilterAutocomplete';

const RecipeBrowseBy = ({ title, subtitle }) => {
  const { t } = useTranslation();
  const [{ browseByFacet }] = useRecipeFilterContext();

  if (_isEmpty(browseByFacet)) return null;

  const hasAutocomplete = _includes(
    [CONST.RECIPE.FACET.INGREDIENT],
    browseByFacet.facets && browseByFacet.facets[0].code,
  );
  // TODO to be used on SAPAM-2552
  // const isByProduct = _includes(
  //   [CONST.RECIPE.FACET.SUPERCAT],
  //   browseByFacet.facets && browseByFacet.facets[0].code,
  // );
  const isByProduct = false;
  const cssPrefix = hasAutocomplete ? 'ingredients' : 'products';

  const onChangeAutocomplete = selected => {
    window.location.href = `${window.location.pathname}${selected.url}`;
  };

  const calculateSelectedValue = (index, attr = 'code') => {
    const selectedValue = _find(browseByFacet.facets[index].values, {
      selected: true,
    });
    return (selectedValue && selectedValue[attr]) || '';
  };

  const onChangeSelect = e => {
    const code = e.currentTarget.value;
    const { index } = e.currentTarget.dataset;
    const selected = _find(browseByFacet.facets[index].values, { code });
    if (selected || code === '') {
      window.location.href = `${window.location.pathname}${
        selected ? selected.query.url : code
      }`;
    }
  };

  return (
    <div className={`dln-recipe-by-${cssPrefix}__search-section`}>
      <h1 className={`dln-recipe-by-${cssPrefix}__title`}>{title}</h1>
      {!hasAutocomplete && (
        <p className='dln-recipe-by-products__browse-product'>{subtitle}</p>
      )}
      {hasAutocomplete ? (
        <FilterAutocomplete
          id={`autocomplete_${browseByFacet.facets[0].code}`}
          values={browseByFacet.facets[0].values}
          selectedValue={calculateSelectedValue(0, 'name')}
          onChange={onChangeAutocomplete}
        />
      ) : (
        <div className='dln-recipe-by-products__selects-wrap'>
          {browseByFacet.facets.map((facet, index) => (
            <Select
              key={facet.code}
              id={`select_${facet.code}`}
              hasPlaceholder={!isByProduct}
              placeholderLabel={t('form.select.choose.label')}
              value={calculateSelectedValue(index)}
              index={index}
              values={facet.values}
              onChange={onChangeSelect}
            />
          ))}
        </div>
      )}
    </div>
  );
};

RecipeBrowseBy.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

RecipeBrowseBy.defaultProps = {
  title: null,
  subtitle: null,
};

export default RecipeBrowseBy;
